import styled from 'styled-components';

import { Typography } from '@mui/material';

import { StyledSelect } from 'components/Input/styles';

export const StyledCell = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
  min-width: 0;
`;

// The shared input styles paint the select white, which shows as a box on the row's hover background.
export const StyledArcSelect = styled(StyledSelect)`
  background-color: transparent;
`;

export const StyledSelectHint = styled.span`
  display: flex;
  min-width: 0;
`;

// Only read through aria-describedby, which still includes the text of a hidden element it references.
export const StyledAriaDescription = styled.span`
  display: none;
`;

export const StyledRegistrationStatus = styled(Typography).attrs({ variant: 'caption' })`
  white-space: nowrap;
`;

export const StyledRetryButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
`;

export const StyledReadOnlyLabel = styled(Typography).attrs({ variant: 'body1' })`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
